export default __webpack_public_path__ + "static/media/Vistasis_naslovna_transp.fa6d3b0e.png";